import { AnalyticsBrowser } from '@segment/analytics-next'
import { getEnv } from '@/env';

export const analytics = AnalyticsBrowser.load({
    writeKey: getEnv('VITE_SEGMENT_WRITE_KEY'),
});

// Expose analytics to window for use in Blade templates
if (typeof window !== 'undefined') {
    (window as any).analytics = analytics;
}
